import Label from "@/components/ui/Label";
import clsx from "clsx";
import styles from "./index.module.css";

type ProductLabelsProps = {
  className?: string;
  isDark?: boolean;
  labels:
    | {
        labelType: string;
        value: string;
      }[]
    | undefined;
};

const ProductLabels = ({ className, labels, isDark }: ProductLabelsProps) => {
  if (!labels) return null;

  return (
    <div className={clsx(styles.labels, className)}>
      {labels.map((label, key) => (
        <Label isDark={isDark} key={key} label={label} />
      ))}
    </div>
  );
};

export default ProductLabels;
